(function () {
  "use strict";
  if (window.referHoneyOfferLoaded) return;
  window.referHoneyOfferLoaded = true;
  var started = false;
  var closeIcon = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
  var copyIcon = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="4" y="7" width="13" height="14" rx="2"/><path d="M9 3h10a2 2 0 0 1 2 2v10"/></svg>';
  var gift = '<div class="rh-gift-orbit" aria-hidden="true"><span class="rh-gift-halo"></span><svg class="rh-gift" viewBox="0 0 120 120" fill="none"><ellipse cx="60" cy="104" rx="29" ry="5" fill="#9B6500" opacity=".12"/><g class="rh-gift-box"><path d="M29 53h62v43a5 5 0 0 1-5 5H34a5 5 0 0 1-5-5V53Z" fill="#F4B942" stroke="#B77B12" stroke-width="1.5"/><path d="M55 53h12v48H55z" fill="#FFF1C1"/><path d="M35 60v33" stroke="#FFE099" stroke-width="2" stroke-linecap="round"/></g><g class="rh-gift-lid"><rect x="23" y="40" width="74" height="17" rx="4" fill="#FFD577" stroke="#B77B12" stroke-width="1.5"/><path d="M55 40h12v17H55z" fill="#FFF1C1"/><path d="M60 40C22 39 37 6 51 24c5 6 9 16 9 16Zm0 0c38-1 23-34 9-16-5 6-9 16-9 16Z" fill="#FFE9AD" stroke="#B77B12" stroke-width="2"/></g></svg><span class="rh-gift-spark rh-spark-one">✦</span><span class="rh-gift-spark rh-spark-two">✧</span><span class="rh-gift-spark rh-spark-three">✦</span></div>';

  function start() {
    var incoming = window.referHoneyIncomingOffer;
    var config = document.querySelector("[data-referhoney-offer]");
    if (started || !config) return;
    config.dataset.offerState = !incoming ? "no-referral" : "captured";
    if (!incoming || (window.Shopify && window.Shopify.designMode)) return;
    var endpoint = new URL(config.dataset.endpoint, window.location.origin);
    if (endpoint.origin !== window.location.origin) return;
    started = true;
    config.dataset.offerState = "loading";
    endpoint.searchParams.set("ref", incoming.ref);
    endpoint.searchParams.set("clickedAt", incoming.clickedAt);
    endpoint.searchParams.set("referralSignature", incoming.signature);

    async function requestOffer(reveal) {
      var url = new URL(endpoint);
      if (reveal) url.searchParams.set("reveal", "1");
      var response = await fetch(url.toString(), { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" }, signal: AbortSignal.timeout(10000) });
      config.dataset.offerStatus = String(response.status);
      if (!response.ok) throw new Error("Offer unavailable");
      var offer = await response.json();
      if (typeof offer.creatorName !== "string" || typeof offer.offerLabel !== "string" || !offer.creatorName.trim() || !offer.offerLabel.trim() || (reveal && (typeof offer.code !== "string" || !offer.code.trim()))) throw new Error("Offer unavailable");
      return offer;
    }

    requestOffer(false).then(function (offer) {
      config.dataset.offerState = "ready";
      var dialog = document.createElement("dialog");
      dialog.id = "referhoney-offer-dialog";
      dialog.setAttribute("aria-labelledby", "rh-offer-title");
      dialog.setAttribute("aria-describedby", "rh-offer-description");
      dialog.innerHTML = '<button type="button" class="rh-offer-close" aria-label="Close discount offer">' + closeIcon + '</button><div class="rh-offer-kicker"><span></span>A LITTLE SOMETHING FOR YOU</div>' + gift + '<h2 id="rh-offer-title"></h2><p id="rh-offer-description">Your next favourite is a little closer.<br>Unwrap your exclusive discount below.</p><div class="rh-offer-action"><button type="button" class="rh-offer-reveal">Reveal discount code <span aria-hidden="true">↗</span></button></div><p class="rh-offer-message" role="status" aria-live="polite"></p><p class="rh-offer-terms">No sign-up needed. Valid on eligible purchases.</p><button type="button" class="rh-offer-continue" hidden>Continue shopping <span aria-hidden="true">→</span></button><div class="rh-offer-confetti" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>';
      dialog.querySelector("h2").textContent = offer.creatorName + " sent you " + offer.offerLabel + " off!";
      var reveal = dialog.querySelector(".rh-offer-reveal");
      var message = dialog.querySelector(".rh-offer-message");
      var description = dialog.querySelector("#rh-offer-description");
      var action = dialog.querySelector(".rh-offer-action");
      var continueButton = dialog.querySelector(".rh-offer-continue");
      var previousOverflow = document.body.style.overflow;
      var closing = false;
      function close() {
        if (closing) return;
        closing = true;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) dialog.close();
        else {
          dialog.classList.add("is-closing");
          window.setTimeout(function () { if (dialog.open) dialog.close(); }, 170);
        }
      }
      dialog.addEventListener("cancel", function (event) { event.preventDefault(); close(); });
      dialog.querySelector(".rh-offer-close").addEventListener("click", close);
      continueButton.addEventListener("click", close);
      dialog.addEventListener("click", function (event) {
        var bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) close();
      });
      dialog.addEventListener("close", function () {
        document.body.style.overflow = previousOverflow;
        dialog.remove();
        delete window.referHoneyIncomingOffer;
      }, { once: true });
      reveal.addEventListener("click", async function () {
        reveal.disabled = true;
        dialog.classList.add("is-revealing");
        reveal.textContent = "Revealing your code…";
        message.textContent = "";
        try {
          var revealed = await requestOffer(true);
          if (!dialog.open || closing) return;
          dialog.classList.remove("is-revealing");
          dialog.classList.add("is-revealed");
          dialog.querySelector(".rh-offer-kicker").textContent = "YOUR GIFT, UNLOCKED";
          dialog.querySelector("h2").textContent = revealed.creatorName + " sent you " + revealed.offerLabel + " off!";
          description.textContent = "A little thank-you, ready to make your day.";
          var copy = document.createElement("button");
          copy.type = "button";
          copy.className = "rh-offer-code";
          copy.setAttribute("aria-label", "Copy discount code " + revealed.code);
          var code = document.createElement("strong");
          code.textContent = revealed.code;
          var codeLabel = document.createElement("span");
          codeLabel.className = "rh-code-content";
          var caption = document.createElement("small");
          caption.textContent = "YOUR DISCOUNT CODE";
          codeLabel.append(caption, code);
          copy.append(codeLabel);
          copy.insertAdjacentHTML("beforeend", copyIcon);
          copy.addEventListener("click", async function () {
            try {
              await navigator.clipboard.writeText(revealed.code);
              message.textContent = "Copied! Your discount code is ready.";
              copy.classList.add("is-copied");
              copy.querySelector("svg").innerHTML = '<path d="m5 12 4 4L19 6"/>';
              copy.setAttribute("aria-label", "Copy discount code again " + revealed.code);
            } catch (_) {
              if (!action.querySelector("input")) {
                var manual = document.createElement("input");
                manual.type = "text";
                manual.readOnly = true;
                manual.value = revealed.code;
                manual.setAttribute("aria-label", "Discount code to copy manually");
                action.append(manual);
              }
              var input = action.querySelector("input");
              input.focus();
              input.select();
              message.textContent = "Select and copy your code above.";
            }
          });
          action.replaceChildren(copy);
          dialog.querySelector(".rh-offer-terms").hidden = true;
          continueButton.hidden = false;
          copy.focus();
        } catch (_) {
          if (!dialog.open || closing) return;
          dialog.classList.remove("is-revealing");
          reveal.disabled = false;
          reveal.textContent = "Try again";
          message.textContent = "We couldn’t reveal this offer. Try again or continue shopping.";
          continueButton.hidden = false;
          reveal.focus();
        }
      });
      document.body.append(dialog);
      dialog.showModal();
      document.body.style.overflow = "hidden";
      reveal.focus();
    }).catch(function () {
      config.dataset.offerState = "unavailable";
      delete window.referHoneyIncomingOffer;
    });
  }
  document.addEventListener("referhoney:offer-ready", start);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
